// To-do list (/todo-list) and the task form. Status and priority names come
// from the shared `tasks.*` texts; stored task texts stay as they are.
const todo = {
  page: {
    title: 'To-do List',
    subtitle: 'See every task, update its status and keep track.',
  },
  actions: {
    add: 'New Task',
  },
  stats: {
    total: 'Total Tasks',
    totalShort: 'Total',
    pending: 'Pending',
    pendingShort: 'Pending',
    inProgress: 'In Progress',
    inProgressShort: 'In progress',
    completed: 'Completed',
    completedShort: 'Done',
    share: '{{percent}}% of all tasks',
  },
  toolbar: {
    search: 'Search tasks, descriptions or people…',
    searchShort: 'Search tasks…',
    status: 'Task status',
    all: 'All',
    mine: 'Assigned to me',
    mineHint: 'Only tasks assigned to you',
    overdue: 'Overdue',
    overdueHint: 'Open tasks past their due date',
    sort: 'Sort',
    sortBy: {
      createdAt: 'Created',
      dueDate: 'Due date',
      priority: 'Priority',
      status: 'Status',
      title: 'Task name',
    },
    asc: 'Ascending',
    desc: 'Descending',
  },
  columns: {
    title: 'Task',
    status: 'Status',
    priority: 'Priority',
    assignee: 'Assigned to',
    dueDate: 'Due Date',
    createdAt: 'Created',
    createdBy: 'Created by',
  },
  table: {
    listLabel: 'Task list',
    empty: 'No tasks found',
    rangeOf: 'of {{total}} tasks',
    ofTotal: 'out of {{total}} tasks',
    jump: 'Go to page',
    more: '+{{count}} more',
    overdue: 'Overdue',
    changeStatus: 'Change status',
  },
  panel: {
    label: 'Selected task',
    heading: 'Task',
    edit: 'Edit',
    delete: 'Delete',
    description: 'Description',
    noDescription: 'No description',
    assignees: 'Assigned to',
    statusTitle: 'Change Status',
    readOnly: 'Only the people the task is assigned to and admins can change its status.',
    dueDate: 'Due date',
    createdAt: 'Created',
    createdBy: 'Created by',
    completedAt: 'Completed',
    markDone: 'Mark as Completed',
    reopen: 'Reopen (Pending)',
    reopenHint: 'Sets the task back to "Pending"',
    priority: '{{priority}} priority',
    auto: 'Automatic',
    autoHint: 'Created automatically by the system',
    accounting: 'Accounting',
    accountingHint: 'Task opened for the accounting team for a project; completing it completes the rest of its group',
    system: 'System',
  },
  form: {
    newTitle: 'Create New Task',
    editTitle: 'Edit Task',
    subtitle: 'Assign the task to one or more people.',
    title: 'Task title',
    titlePlaceholder: 'Enter the task title…',
    description: 'Description',
    descriptionPlaceholder: 'Enter the task description…',
    priority: 'Priority',
    status: 'Status',
    dueDate: 'Due date',
    assignees: 'Assigned to',
    assigneesPlaceholder: 'Choose people',
    assigneeSearch: 'Search employees…',
    noResults: 'No results',
    selected_one: '{{count}} person selected',
    selected_other: '{{count}} people selected',
    remove: 'Remove {{name}}',
    accountingNote: 'New tasks with "proje" in the title or description also open a task for the accounting team.',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    saving: 'Saving…',
  },
  delete: {
    title: 'Delete Task',
    message: 'Are you sure you want to delete "{{title}}"? This can’t be undone.',
    confirm: 'Yes, delete',
    cancel: 'Cancel',
  },
  toast: {
    loadError: 'The tasks could not be loaded',
    notFound: 'Task not found',
    completedSynced_one: 'Task completed, and {{count}} related accounting task was completed too',
    completedSynced_other: 'Task completed, and {{count}} related accounting tasks were completed too',
    completed: 'Task completed',
    statusUpdated: 'Task status updated',
    statusError: 'The task status could not be updated',
    deleted: 'Task deleted',
    deleteError: 'The task could not be deleted',
    titleRequired: 'A task title is required',
    assigneeRequired: 'Assign at least one person',
    updated: 'Task updated',
    createdWithAccounting_one: 'Task created, and {{count}} accounting team member got a task automatically',
    createdWithAccounting_other: 'Task created, and {{count}} accounting team members got a task automatically',
    created: 'Task created',
    saveError: 'The task could not be saved',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default todo;
